import { connect } from 'react-redux';
import _ from 'lodash';
import RoomDetail from './roomDetail';

const mapStateToProps = (state, ownProps) => {
  const { room_id } = _.get(ownProps, 'match.params', null);
  return {
    room_id,
  };
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(RoomDetail);